import request from "./request";

/** 请求资源 */
export const parseSourceUrl = (body)=>request.post('/fetch', body)